<template>
  <div class="yy">
    <!-- 上盒子 -->
    <div class="yy-box1">
      <ul>
        <li><router-link to="/honor/myzs1">企业简介</router-link></li>
        <li><router-link to="/honor/myzs2">企业文化</router-link></li>
        <li><router-link to="/honor/myzs3">组织架构</router-link></li>
        <li><router-link to="/honor/myzs4">企业资质</router-link></li>
        <li><router-link to="/honor/myzs7">企业体系认证</router-link></li>
        <li><router-link to="/honor/myzs8">企业信用认证</router-link></li>
        <li><router-link to="/honor/myzs5">荣誉证书</router-link></li>
        <!-- <li><router-link to="/honor/myzs6">新闻动态</router-link></li> -->
      </ul>
    </div>

    <!-- 下盒子：一行四列，图片+文字 -->
    <div class="ryzs">
      <div class="credit-card" v-for="(item, idx) in creditList" :key="idx">
        <!-- <img :src="item.url" :alt="item.title" /> -->
        <el-image
                  :src="item.url"
                  class="image-placeholder"
                  fit="cover"
                  :preview-src-list="[item.url]"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
        <div class="card-title">{{ item.title }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      creditList: [
        { url: 'https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-14-15-48-17-361%E8%AF%9A%E4%BF%A1%E4%BE%9B%E5%BA%94%E5%95%86%E7%AD%89%E7%BA%A7%E8%AF%81%E4%B9%A6.jpg', title: '诚信供应商等级证书' },
        { url: 'https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-14-15-48-17-361%E8%AF%9A%E4%BF%A1%E4%BE%9B%E5%BA%94%E5%95%86%E7%AD%89%E7%BA%A7%E8%AF%81%E4%B9%A6.jpg', title: '诚信供应商等级证书（副本）' },
        { url: 'https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-14-15-48-43-119%E8%AF%9A%E4%BF%A1%E4%BC%81%E4%B8%9A%E5%AE%B6.jpg', title: '诚信企业家' },
        { url: 'https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-14-15-48-43-119%E8%AF%9A%E4%BF%A1%E4%BC%81%E4%B8%9A%E5%AE%B6.jpg', title: '诚信企业家（副本）' },
        { url: 'https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-14-15-50-02-919%E7%AB%8B%E4%BF%A1%E5%8D%95%E4%BD%8D%E8%AF%81%E4%B9%A6.jpg', title: '立信单位证书' },
        { url: 'https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-14-15-49-52-360%E4%BC%81%E4%B8%9A%E4%BF%A1%E7%94%A8%E7%AD%89%E7%BA%A7%E8%AF%81%E4%B9%A6.jpg', title: '企业信用等级证书' },
        { url: 'https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-14-15-50-13-414%E8%A1%8C%E4%B8%9A%E8%AF%9A%E4%BF%A1%E5%8D%95%E4%BD%8D%E8%AF%81%E4%B9%A6.jpg', title: '行业诚信单位证书' },
        { url: 'https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-14-15-51-14-412%E8%B4%A8%E9%87%8F%E6%9C%8D%E5%8A%A1%E8%AF%9A%E4%BF%A1%E5%8D%95%E4%BD%8D%E8%AF%81%E4%B9%A6.jpg', title: '质量服务诚信单位证书' },
        { url: 'https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-14-15-51-45-903%E9%87%8D%E5%90%88%E5%90%8C%E5%AE%88%E4%BF%A1%E7%94%A8%E4%BC%81%E4%B8%9A.jpg', title: '重合同守信用企业' },
        { url: 'https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-14-15-51-36-505%E8%B5%84%E4%BF%A1%E7%AD%89%E7%BA%A7%E8%AF%81%E4%B9%A6.jpg', title: '资信等级证书' },
        { url: 'https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-14-15-47-54-2233A%E7%89%8C%E5%8C%BE-%E7%94%B5%E5%AD%90%E7%89%88.jpg', title: '3A牌匾' }
      ]
    };
  }
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}

/* 信用认证页面 - 一行四列网格 */
.ryzs {
  width: 80%;
  margin: 30px auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.credit-card {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s, box-shadow 0.3s;
  text-align: center;
}

.credit-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 25px rgba(0, 0, 0, 0.15);
}
.credit-card:hover .card-title {
  color:#b81212;
}

.credit-card .image-placeholder {
  height: 200px;
  object-fit: cover;
  display: block;
  padding: 10px 0;
}
/deep/.el-image__inner {
  width:auto;
}

.card-title {
  padding: 10px 8px;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  background: #fafafa;
  border-top: 1px solid #eee;
}

/* 响应式：平板显示两列，手机显示一列 */
@media (max-width: 992px) {
  .ryzs {
    grid-template-columns: repeat(2, 1fr);
    width: 90%;
  }
}
@media (max-width: 576px) {
  .ryzs {
    grid-template-columns: 1fr;
    width: 95%;
  }
}
</style>